import React from 'react';
import {Textbox} from '../../types'

type Props = {
  textbox: Textbox;
}

const TextBox = (props: Props): JSX.Element => {
  const {textbox} = props;
  return (
    <div className={`stage-gallery__text-box ${textbox.position} high-stage video-text-box `}>
      <span className="icon ic-arrowsRight stage-gallery__text-icon" aria-hidden="true"/>
      <div className="link-headline__wrapper hl-3">
        <p className="hl-3 topic-stage-headline">{textbox.title}</p>
      </div>
    </div>
  );
}

export default TextBox;
